Object.defineProperty(exports, "__esModule", { value: true });
exports.flagsClient = void 0;
const unleash_proxy_client_1 = require("unleash-proxy-client");
const utils_1 = require("./utils");
/**
 * Simplified client SDK to work offline with pre-evaluated flags
 */
const flagsClient = (toggles = []) => {
    const client = new unleash_proxy_client_1.UnleashClient({
        bootstrap: toggles,
        ...(0, utils_1.getDefaultClientConfig)(),
        refreshInterval: 0,
        disableRefresh: true,
        bootstrapOverride: true,
        disableMetrics: true,
        storageProvider: {
            get: async (_name) => { },
            save: async (_name, _value) => { },
        },
    });
    return {
        isEnabled: (name) => client.isEnabled(name),
        getVariant: (name) => client.getVariant(name),
    };
};
exports.flagsClient = flagsClient;
